import React from 'react';
import { List } from 'semantic-ui-react';

import FieldValues from 'components/FieldValues';
import WizardEventSummarySection from 'components/WizardEventSummarySection';
import { SprayEventOperation } from 'services/sprayEvents/types';
import SummaryCalibrationsList from './components/SummaryCalibrationsList';

interface Props {
    sprayEventOperation: SprayEventOperation;
}

export default function SummaryCalibrations({
    sprayEventOperation
}: Props): React.ReactElement {
    return (
        <WizardEventSummarySection title="Calibrations" readOnly>
            <List className="summary-list">
                <FieldValues
                    fieldNames={['sprayApplicationRate', 'sprayEntityIds']}
                >
                    {({
                        sprayApplicationRate,
                        sprayEntityIds
                    }): React.ReactElement => {
                        return (
                            <SummaryCalibrationsList
                                equipmentSetId={
                                    sprayEventOperation?.sprayEquipmentSetId
                                }
                                applicationRate={sprayApplicationRate}
                                entityIds={sprayEntityIds}
                            />
                        );
                    }}
                </FieldValues>
            </List>
        </WizardEventSummarySection>
    );
}
